var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "app-button",
      attrs: { disabled: _vm.isDisabled },
      on: {
        click: function($event) {
          $event.stopPropagation()
          return _vm.click.apply(null, arguments)
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47f4012e", { render: render, staticRenderFns: staticRenderFns })
  }
}